import React from 'react'
import {
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion'

const QuestionWithAnswer = props => (
  <AccordionItem>
    <AccordionItemTitle>
      <div className='u-position-relative'>
        <span>» {props.question}</span>{' '}
        <div className='accordion__arrow' role='presentation' />
      </div>
    </AccordionItemTitle>
    <AccordionItemBody>
      <div className='cardz'>
        <div className='cardz-body'>{props.children}</div>
      </div>
    </AccordionItemBody>
  </AccordionItem>
)
export default QuestionWithAnswer



// WEBPACK FOOTER //
// ./src/components/QuestionWithAnswer.js